// !this checks whether the there is login already

import { Injectable } from "@angular/core";
import { CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '../models/app-state.models';
import { exhaustMap, map, take, tap } from 'rxjs/operators';
import { sessionSelectors } from "src/app/store/selectors";

@Injectable()
export class SessionGuard implements CanActivate {
    constructor(
        private router: Router,
        private store: Store<AppState>,
    ) { }

    async canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise<boolean> {
        return this.store.select(sessionSelectors.selectLoginStatus)
            .pipe(
                take(1),
                map(r => {
                    if (r === false) {
                        this.router.navigate(['/auth', 'login']);
                    }
                    if (r === null) {
                        return true
                    }
                    return r;
                })
            )
            .toPromise()
            .catch(error => {
                console.log('SessionGuard', `Failed to verify route activation`, error);
                this.router.navigate(['/auth', 'logout']);
                return false;
            });
    }
}
